function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-749a4e36\",\"scoped\":false,\"hasInlineConfig\":false}!sass-loader?data=@import \"./src/scss/variables\";@import \"./src/scss/mixins\";@import \"./src/scss/helper\";!./style.scss")
}
var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Info.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-749a4e36\",\"hasScoped\":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Info.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/info/Info.vue
// module id = 561
// module chunks = 0